import React, { useState, useEffect } from "react";
import Topheader from "./components/HomePage/top_header";
import Header from "./components/HomePage/header";
import Pricing from "./components/HomePage/pricing";
import Product_section from "./components/HomePage/product_section";
import Featured from "./components/HomePage/featured";
import Footer from "./components/HomePage/footer";
import Stats from "./components/HomePage/stats";
import NewsletterPopup from "./Account/NewsletterPopup";
import CoreFeatures from "./components/HomePage/corefeature";
import CtaPage from "./components/HomePage/ctapage";
import { Helmet } from "react-helmet";

export default function Home() {
  const [plans, setPlans] = useState([]);

  // Fetch subscription plans from the server
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await fetch("/api/category/main"); // Adjust the API endpoint accordingly
        if (!response.ok) {
          throw new Error("Failed to fetch subscription plans");
        }
        const data = await response.json();

        // Transform the fetched data to match the expected structure
        const mappedPlans = data.map((plan) => {
          // Parse cancelledMRP and price to numbers
          const cancelledMRP = parseFloat(
            plan.dynamicPricing?.basePrice || "0"
          );
          const price = parseFloat(plan.price || "0");

          // Calculate savings percentage
          const savingsPercent = cancelledMRP
            ? Math.round(((cancelledMRP - price) / cancelledMRP) * 100)
            : 0; // Default to 0 if cancelledMRP is 0
          const freeMonths = plan.dynamicPricing?.freeMonths || "No freeMonths";

          return {
            plan: plan.name, // Assuming 'name' is the title
            price, // Assuming 'price' field exists
            planID: plan.planID, // Assuming 'planID' exists
            duration: plan.months, // Assuming 'months' field exists
            features: plan.description.split("\n"), // Assuming 'description' contains features
            savings: savingsPercent > 0 ? `${savingsPercent}` : "No Savings",
            additionalDetails:
              plan.additionalDetails || "No additional details",
            promotion: plan.promotion || "No promotion",
            freeMonths,
            cancelledMRP:
              cancelledMRP > 0 ? `$${cancelledMRP.toFixed(2)}` : "$0",
          };
        });

        setPlans(mappedPlans);
      } catch {
        setPlans([]);
      }
    };

    fetchPricingData();
  }, []);

  return (
    <>
      <Helmet>
        <title>PrepNexis AI: Best PTE Online Platform for PTE Preparation</title>
        <meta
          name="description"
          content="PrepNexis AI - The Best PTE Online Platform for PTE Preparation! Get AI-powered mock tests, real-time scoring, and expert feedback to boost your PTE exam performance."
        />
        <meta
          name="keywords"
          content="Prepnexis,prepnexis.com,Best PTE online platform, PTE preparation, PTE mock test, AI-powered PTE practice, free PTE test, online PTE exam, PTE score predictor"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prepnexis.com" />

        {/* Open Graph for Social Sharing */}
        <meta
          property="og:title"
          content="PrepNexis AI: Best PTE Online Platform for PTE Preparation"
        />
        <meta
          property="og:description"
          content="AI-powered PTE mock tests with real-time scoring and expert guidance to help you succeed."
        />
        <meta property="og:image" content="https://prepnexis.com/logo.png" />
      </Helmet>

      <Topheader plans={plans[1]} />
      <Header />
      <Product_section />
      <CoreFeatures />
      <CtaPage />
      <Pricing plans={plans} />
      <Featured />
      <Stats />
      <NewsletterPopup />
      <Footer />
    </>
  );
}
